import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { useNotificationContext } from "../NotificationContext";
import NotificationTemplete from "../NotificationTemplate";

const Notifications = () => {
  const { notifications = [], removeNotification } = useNotificationContext();
  const { pathname } = useLocation();
  const StoreId = localStorage.getItem("store");
  const navigate = useNavigate();

  if (pathname === "/chat" || pathname === "/internal-chat") return null;

  return (
    <>
      <div className="fixed top-6 right-6 z-50 flex flex-col gap-4">
        {[...notifications].reverse().map((notification) => (
          <NotificationTemplete
            key={notification.id}
            notification={notification}
            onClick={() => {
              if (notification?.redirect) {
                navigate(notification.redirect, {
                  state:
                    notification.redirect === "/chat"
                      ? {
                          whatsapp_no: notification?.phoneNumber,
                          phone_id: notification?.Business_id,
                          store_id: StoreId,
                        }
                      : notification.redirect === "/chat-agent"
                        ? {
                            user_name: notification?.sender,
                          }
                        : undefined,
                });
              }
            }}
            onRemove={removeNotification}
          />
        ))}
      </div>

      <style>{`
                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fade-in {
                    animation: fade-in 0.4s ease-out;
                }
            `}</style>
    </>
  );
};

export default Notifications;

// export default WebsocketNotifications
